import { Dispatcher } from '@Corim/architecture-backend'

export default Dispatcher(false, true)